module.exports = __webpack_public_path__ + "img/立兴.49ab58db.png";